module.exports = __webpack_public_path__ + "media/images/map/plus-icon-e742b513d8aaff3ee0a16a94215106b7.svg";